/**
 * Wizytówki Google - Custom Icon
 * Pin with checkmark in brand colors
 */
import React from 'react';

export default function WizytowkiIcon({ size = 32, className = '', darkMode = false }) {
  const strokeColor = darkMode ? '#FFFFFF' : '#0B0B0B';
  
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 256 256" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Pin outline */}
      <path 
        d="M128 240c-8.5 0-16.3-4.2-20.9-11.2C89.3 202.4 48 143.7 48 104
           C48 59.8 83.8 24 128 24s80 35.8 80 80c0 39.7-41.3 98.4-59.1 124.8
           c-4.6 7-12.4 11.2-20.9 11.2z"
        stroke={strokeColor} 
        strokeWidth="12" 
        strokeLinejoin="round"
      />
      {/* Inner circle */}
      <circle 
        cx="128" 
        cy="104" 
        r="46" 
        stroke={strokeColor} 
        strokeWidth="12"
      />
      {/* Check */}
      <path 
        d="M104 106l16 16 36-40" 
        stroke="#E6007A" 
        strokeWidth="14" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );
}
